import { render, staticRenderFns } from "./PrecificationDetails.vue?vue&type=template&id=1c65eb26"
import script from "./PrecificationDetails.vue?vue&type=script&lang=js"
export * from "./PrecificationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports